module.exports = __webpack_public_path__ + "static/media/puzzlepiece2.fde9bbc8.svg";